const terms = [
  ["Contention", "A team's main argument or reason for supporting its side."],
  ["Claim", "What the team says is true."],
  ["Warrant", "The reasoning explaining why the claim is true."],
  ["Evidence", "Information or sources used to support an argument."],
  ["Impact", "Why the argument matters—the consequence if it is true."],
  ["Clash", "Where the two teams directly disagree or respond to each other."],
  ["Weighing", "Why one impact matters more because it is larger, likelier, or sooner."],
  ["Extension", "Continuing an earlier argument into a later speech."],
  ["Dropped argument", "An unanswered argument; consider its importance and later use."],
  ["Turn", "An argument that says the opponent causes the opposite result or worsens it."],
  ["Frontline", "Responding to attacks against your own argument."],
  ["Collapse", "Focusing later speeches on fewer important arguments."],
  ["Voting issue", "An argument or comparison important to deciding the round."],
  ["Final Focus", "The final speech where each team explains what should decide the round."],
  ["Flow", "The judge's organized notes tracking arguments and responses."],
];

export default function DebateTerms() {
  return <details className="debate-terms" data-testid="debate-terms"><summary data-testid="debate-terms-toggle">Debate Terms</summary><dl>{terms.map(([term, meaning]) => <div key={term}><dt>{term}</dt><dd>{meaning}</dd></div>)}</dl></details>;
}